import { z } from 'zod';
// Normalized cursor position reported by the host (0..1 across screen).
// Sent from host → relay → client periodically (e.g. 30 Hz) so the client
// can render a cursor overlay at the host's actual cursor position,
// regardless of whether the client or someone at the host moved it.
export const CursorPosition = z.object({
    nx: z.number().min(0).max(1),
    ny: z.number().min(0).max(1),
});
//# sourceMappingURL=cursor.js.map